var Base = require('_js/base'),
  $ = require('jquery'),
  ko = require('knockout');

function HeaderViewModel() {
  this.$header = $('.main-header');
  this.init();
}

HeaderViewModel.prototype = new Base();

HeaderViewModel.prototype.init = function() {
  var self = this;

  $('.main-header').scrollToFixed({
    spacerClass: 'scrollToFixed-spacing'
  });

  // Looking for what determines the size for the element beneath .main-header?
  // It is in the toggle function of app.js: scrollToFixed plugin.
  // See also usage of the scrollToFixed-styling css class.

  // Don't resize the header if we're on a mobile device.
  // I'm doing this based on size and not user agent because all the styling is associated
  // to the device size.
  if ($(document).width() > 1024) {
    $(document).on(
      'scroll',
      function() {
        if ($(document).scrollTop() > 100) {
          this.$header.addClass('reduced');
        } else {
          this.$header.removeClass('reduced');
        }
      }.bind(this)
    );
  }

  self.hoverDelay = ko.observable(true);

  $('.header-menu').on('mouseleave', function() {
    self.hoverDelay(true);
  });

  $('.header-menu-item-link').on('mouseenter', function() {
    var menu = $(this);
    var submenu = menu.parent().find('.header-menu-sub-item');

    setTimeout(function() {
      var isHovered = menu.filter(function() {
        return menu.is(':hover');
      });

      if (isHovered.length > 0) {
        submenu.addClass('is-visible');
        submenu.css('min-width', menu.outerWidth());

        var offsetRight =
          submenu[0].getBoundingClientRect().right - $(window).innerWidth();
        if (offsetRight > 0) {
          var whitespaceRightOfMenu =
            $(window).innerWidth() - menu[0].getBoundingClientRect().right;
          submenu.css('right', whitespaceRightOfMenu);
        }
      }
    }, self.hoverDelay() ? 500 : 0);
  });

  $('.header-menu-item-link').on('mouseleave', function() {
    var menu = $(this);
    var submenu = menu.parent().find('.header-menu-sub-item.is-visible');

    self.hoverDelay(false);

    setTimeout(function() {
      var keepSubMenuOpen = false;

      var menuIsHovered = menu.filter(function() {
        return menu.is(':hover');
      });

      var submenuIsHovered = submenu.filter(function() {
        return submenu.is(':hover');
      });

      if (menuIsHovered.length > 0 || submenuIsHovered.length > 0) {
        keepSubMenuOpen = true;
      }

      if (!keepSubMenuOpen) {
        submenu.removeClass('is-visible');
        submenu.css('right', 'auto');
      }
      menu.removeClass('is-focused');
    }, self.hoverDelay() ? 200 : 0);
  });

  $('.header-menu-sub-item').on('mouseleave', function() {
    var submenu = $(this);
    submenu.removeClass('is-visible');
  });

  //Support-menu-link toggler
  $('.support-menu-link').on('click', function(e) {
    var me = $(this);
    var parent = $(this).parent();

    if (me.attr('data-toggle')) {
      e.preventDefault();
    } else {
      return;
    }

    parent.siblings().removeClass('is-open');

    //Remove is-visible
    parent.siblings().each(function() {
      var me = $(this);
      $(
        '.main-header .' + me.find('.support-menu-link').data('toggle')
      ).removeClass('is-visible');
    });

    var toggleItem = $('.main-header .' + me.attr('data-toggle'));

    //if open close
    if (parent.hasClass('is-open')) {
      toggleItem.removeClass('is-visible');

      setTimeout(function() {
        parent.removeClass('is-open');
      }, 300);
    } else {
      //else if closed open
      parent.addClass('is-open');
      toggleItem.addClass('is-visible');
    }
  });

  var mainHeader = $('.main-header');
  var menuItems = $('.support-menu-item');
  var menuItemsContent = [];

  menuItems.each(function() {
    var menuItemContent = mainHeader.find(
      '.' +
        $(this)
          .find('.support-menu-link')
          .data('toggle')
    );
    if (menuItemContent.get(0) !== undefined) {
      menuItemsContent.push(menuItemContent);
    }
  });

    // ----- Add GTM tracking attributes -----
    function addGtmAttributes() {
      $('.header-menu-item-link').each(function() {
        var $topLink = $(this);
        var headerText = $topLink.text();
  
        $topLink.attr('data-gtm-menu-header-text', headerText);
  
        $topLink.parent().find('.header-menu-sub-item a').each(function() {
          var $subA = $(this);
          var subText = $subA.text();
          $subA.attr('data-gtm-menu-header-text', headerText);
          $subA.attr('data-gtm-menu-text', subText);
        });
      });
    }
  
    // run once during init
    addGtmAttributes();
  

  // Listen to clicks on the main-content.
  ko.postbox.subscribe('maincontent', function(newVal) {
    if (newVal === 'click') {
      // Close all menu items.
      removeOpenState(menuItems, menuItemsContent);
    }
  });

  // click outside search button on desktop will hide focus on search button
  $(document).mousedown(function(e) {
    var $searchButtonItem = $('.support-menu-item.search'),
      $searchButtonDesktop = $('[data-toggle="main-search"]'),
      $searchField = $('.support-menu-search-field');

    // if the target of the click isn't the container...
    if (
      !$searchButtonItem.is(e.target) &&
      $searchButtonItem.has(e.target).length === 0
    ) {
      // ... nor a descendant of the container
      $searchButtonDesktop.removeClass('is-active');
      $searchButtonItem.removeClass('is-open');
      $searchField.removeClass('is-open');
    }
  });
};

function removeOpenState(menuItems, menuItemsContent) {
  menuItems.removeClass('is-open');
  for (var i = 0; i < menuItemsContent.length; i++) {
    $(menuItemsContent[i]).removeClass('is-visible');
  }
}

module.exports = HeaderViewModel;
